function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  width: "30",
  height: "30"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M128.8 69L96.6 20.7 49.1 92.1c-17.2 26.4-10.6 60.8 15.9 78 10.6 6.6 21.1 9.3 33 9.3 14.5 0 29.1-5.3 39.7-15.9a56 56 0 0014.1-23.7",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "154.1",
  cy: "100",
  r: "26.3",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "5",
  strokeLinecap: "round",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M156 100l-.9-18.8h-1.9l-.9 18.8v1.9l10 9.4 1.3-1.3-7.6-10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.9 110c-1.1 3.5-1.7 7.3-1.7 11.2 0 20.8 16.8 37.6 37.6 37.6",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeMiterlimit: "10"
})));